import { toCamelCase } from '../utils/caseConverter';
import { getApiHeaders } from '../utils/apiHeaders';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const uploadQuotation = async (data: FormData) => {
  const response = await fetch(`${API_BASE_URL}/api/quotations`, {
    method: 'POST',
    headers: getApiHeaders('form-data'),
    body: data,
  });

  if (!response.ok) {
    const error = await response.text();
    throw new Error(`Upload failed: ${error}`);
  }
};

export const fetchQuotationsForAQuery = (queryID: number) => {
  return fetch(`${API_BASE_URL}/api/quotations/query/${queryID}`, {
           headers: getApiHeaders('none')
        }).then(res => res.json()).then(data => toCamelCase(data));
};
